var map = {
	"./prize-1.png": 173,
	"./prize-1@2x.png": 175,
	"./prize-2.png": 177,
	"./prize-2@2x.png": 179,
	"./prize-3.png": 181,
	"./prize-3@2x.png": 183,
	"./prize-4.png": 185,
	"./prize-4@2x.png": 187,
	"./prize-5.png": 189,
	"./prize-5@2x.png": 191,
	"./prize-6.png": 193,
	"./prize-6@2x.png": 195,
	"./prize-7.png": 197,
	"./prize-7@2x.png": 199,
	"./prize-8.png": 201,
	"./prize-8@2x.png": 203,
	"./prize-9.png": 205,
	"./prize-9@2x.png": 207
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 265;



//////////////////
// WEBPACK FOOTER
// ./themes/hm/sprite ^\.\/prize\-.*\.png$
// module id = 265
// module chunks = 3